export var ModuleConfig;
(function (ModuleConfig) {
    ModuleConfig["TownPlanning"] = "TownPlanningConfig";
    ModuleConfig["Gautrain"] = "GautrainGenericTemplateConfig";
    ModuleConfig["BuildingPlans"] = "BuildingPlansConfig";
    ModuleConfig["BuildingPlansInspectorate"] = "BuildingPlansInspectorateConfig";
    ModuleConfig["Wayleaves"] = "WayleavesConfig";
    ModuleConfig["PropertyAndLease"] = "PropertyAndLeaseConfig";
    ModuleConfig["Cemetery"] = "CemeteryConfig";
    ModuleConfig["PropertyValuation"] = "PropertyValuationConfig";
    ModuleConfig["Advertising"] = "AdvertisingConfig";
    ModuleConfig["EnvironmentalHealth"] = "EnvHealthConfig";
    ModuleConfig["DemolitionManagement"] = "DemolitionManagementConfig";
    ModuleConfig["ZoningCertificate"] = "ZoningCertificateConfig";
    ModuleConfig["TrainingModule"] = "TrainingModuleConfig";
    ModuleConfig["InformalTrade"] = "InformalTradeConfig";
    ModuleConfig["RatesCertificate"] = "RatesCertificateConfig";
    ModuleConfig["BusinessLicence"] = "BusinessLicenceConfig";
    ModuleConfig["ElectricalConnection"] = "ElectricalConnectionConfig";
    ModuleConfig["StreetNaming"] = "StreetNamingConfig";
    ModuleConfig["Mondi"] = "MondiGenericTemplateConfig";
})(ModuleConfig || (ModuleConfig = {}));
